import { css, cx } from '@emotion/css';
import { FormInstance, Modal, ModalProps } from 'antd';
import ForwardFormInstance from 'components/ForwardFormInstance';
import { useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import DepartmentInfoForm, {
  DepartmentInfoFormProps,
  DepartmentInfoFormValues,
} from './DepartmentInfoForm';

export type { DepartmentInfoFormValues } from './DepartmentInfoForm';

export interface DepartmentInfoFormModalProps extends ModalProps {
  formProps: Omit<DepartmentInfoFormProps, 'form' | 'isDefault'>;
  isDefault?: boolean;
}
const DepartmentInfoFormModal = (props: DepartmentInfoFormModalProps) => {
  const { formProps, className, isDefault, ...otherProps } = props;
  const { t } = useTranslate();
  const instRef = useRef<FormInstance<DepartmentInfoFormValues> | null>(null);
  return (
    <Modal
      className={cx(
        css`
          .ant-modal-body {
            max-height: 70vh;
            overflow: auto;
          }
        `,
        className,
      )}
      width={560}
      okText={
        formProps.initialValues === undefined ? t('department.确认新建') : t('modals.确认修改')
      }
      maskClosable={false}
      onOk={() => {
        return instRef.current?.submit?.();
      }}
      {...otherProps}
    >
      <ForwardFormInstance ref={instRef}>
        {(form) => <DepartmentInfoForm {...formProps} form={form} isDefault={isDefault} />}
      </ForwardFormInstance>
    </Modal>
  );
};
export default DepartmentInfoFormModal;
